export default __webpack_public_path__ + "static/media/artists.cc039961.jpg";